import type { ThemeWithoutTokens } from '../theme.types';

export const tagTokens = (theme: ThemeWithoutTokens) =>
  ({
    // Tag Size
    tagHeightSmall: theme.typography.lineHeight.xs,
    tagHeightMedium: theme.typography.lineHeight.s,
    tagHeightLarge: theme.typography.lineHeight.m,

    // Tag Padding
    tagPaddingSmall: theme.space.component.x.xs,
    tagPaddingMedium: theme.space.component.x.s,
    tagPaddingLarge: theme.space.component.x.s,

    // Tag Background
    tagDefaultBackgroundColor: theme.palette.blue400Alpha,
    tagGreenBackgroundColor: theme.palette.green400alpha,
    tagGreyBackgroundColor: theme.palette.grey200,
    tagOrangeBackgroundColor: theme.palette.orange400alpha,
    tagPurpleBackgroundColor: theme.palette.purple400alpha,
    tagRedBackgroundColor: theme.palette.red400alpha,
    tagYellowBackgroundColor: theme.palette.yellow400alpha,
    tagRemovableBackgroundColor: theme.palette.grey100,
    tagDisabledBackgroundColor: theme.palette.grey200,

    // Tag Text Color
    tagDefaultTextColor: theme.colors.body.text,
    tagGreenTextColor: theme.colors.success.textDark,
    tagGreyTextColor: theme.palette.grey700,
    tagOrangeTextColor: theme.colors.warning.textDark,
    tagPurpleTextColor: theme.palette.purple700,
    tagRedTextColor: theme.colors.danger.textDark,
    tagYellowTextColor: theme.palette.yellow700,
    tagDisabledTextColor: theme.colors.disabled.text,

    // Tag Font
    tagFontSize: theme.typography.fontSize.xs,
    tagFontFamily: theme.typography.fontFamily.regular,
    tagFontLineHeight: theme.typography.lineHeight.xs,
    tagFontWeight: theme.typography.fontWeight.semibold,

    // radiuses
    tagRadius: theme.radiuses.m,
  }) as const;
